import React from 'react';

const AWSEnvironmentsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          AWS Environments
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The AWS Environments page allows you to connect and manage your AWS
          accounts. Connected environments enable cost tracking, compliance
          monitoring, and infrastructure management.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Connected Environments
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View your connected AWS accounts:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Account Name:</strong> Friendly name for the environment</li>
          <li><strong>Account ID:</strong> AWS account identifier</li>
          <li><strong>Region:</strong> Primary AWS region</li>
          <li><strong>Status:</strong> Connection health status</li>
          <li><strong>Last Synced:</strong> Most recent data synchronization</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Connecting an AWS Account
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          To connect a new AWS environment:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>Click "Connect AWS Account"</li>
          <li>Deploy the CloudFormation stack in your AWS account</li>
          <li>Enter the required IAM role ARN</li>
          <li>Verify the connection status</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Environment Data
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Connected environments provide:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Cost Data:</strong> Spending and usage metrics</li>
          <li><strong>Resource Inventory:</strong> EC2, S3, RDS, and more</li>
          <li><strong>Compliance Status:</strong> Security and governance checks</li>
          <li><strong>Recommendations:</strong> Cost optimization suggestions</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Environments
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Edit environment settings, update credentials, or disconnect accounts
          that are no longer needed. Regular synchronization ensures your data
          stays current across all connected environments.
        </p>
      </div>

    </>
  );
};

export default AWSEnvironmentsHelp;
